import { applyHeadTags as e } from "./applyHeadTags.mjs";
import { pageMetaStore as t } from "./pageMetaStore.mjs";
import { titleForPathname as n } from "./pageTitleMatch.mjs";
import { descriptionKeyForPathname as r } from "./pageDescriptions.mjs";
import { buildHeadTags as i, isProductionHost as a } from "@maat/api-main/types";
import { useEffect as o, useSyncExternalStore as s } from "react";
import { useLocation as c } from "react-router-dom";
import { useTranslation as l } from "@maat/store-i18n";
//#region src/DocumentHead.tsx
var u = () => {
	let { pathname: u } = c(), { t: d } = l("site"), f = s(t.subscribe, t.getSnapshot, () => null), p = r(u), m = p ? d(p) : void 0;
	return o(() => {
		let t = i({
			...f,
			title: f ? f.title : n(u),
			description: f?.description ?? m
		}, {
			pathname: u,
			noindex: !a(window.location.hostname)
		});
		e(document, t);
	}, [
		u,
		f,
		m
	]), null;
};
//#endregion
export { u as DocumentHead };
